import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { IconButton, Popover, withStyles } from '@material-ui/core';


import { setHelpItemId } from 'src/store/actions/helpActions';

import { selectHelpTabIndex } from 'src/store/selectors/help';
import ButtonDetails from './ButtonDetails';

const styles = ({ palette }) => ({
  icon: {
    color: 'white'
  },
  paper: {
    padding: 12,
    maxWidth: 350
  }
});

function BarButton({
  icon, newsCount, list, bottomButtons, changeTab, setId, seeAll, readAll, changeTabIndex, classes
}) {
  const [anchorRef, setAnchorRef] = useState(null);

  const openDetails = ({ target }) => {
    setAnchorRef(target);
  };

  const closeDetails = () => {
    setAnchorRef(null);
  };

  return (
    <>
      <Popover
        id="popover-positioned-topXXX"
        style={{ width: '300px' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={Boolean(anchorRef)}
        anchorEl={anchorRef}
        onClose={closeDetails}
        PaperProps={{
          className: classes.paper
        }}
      >
        <ButtonDetails
          changeTabIndex={changeTabIndex}
          readAll={readAll}
          list={list}
          bottomButtons={bottomButtons}
          changeTab={changeTab}
          setId={setId}
          seeAll={seeAll}
          hide={closeDetails}
        />
      </Popover>
      <IconButton className={classes.icon} onClick={openDetails}>
        {icon}
        {newsCount > 0 && <span className="news-count">{newsCount > 9 ? '9+' : newsCount}</span>}
      </IconButton>
    </>
  );
}

BarButton.propTypes = {
  changeTab: PropTypes.func.isRequired,
  seeAll: PropTypes.func,
  setId: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.object.isRequired,
  newsCount: PropTypes.number,
  changeTabIndex: PropTypes.number.isRequired,
  list: PropTypes.array,
  bottomButtons: PropTypes.bool,
  readAll: PropTypes.bool
};

BarButton.defaultProps = {
  newsCount: 0,
  list: [],
  bottomButtons: false,
  seeAll: () => {},
  readAll: false
};

const mapStateToProps = (state) => ({
  tabIndex: selectHelpTabIndex(state)
});

const mapDispatchToProps = {
  setId: setHelpItemId
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(BarButton));
